export { default } from './ShowMoreText';
